import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';

const contentInfo = {
  h2: 'How to Use our AI hairstyle simulator to Find best hairstyle',
  h3List: ['Step 1: Pick a style you love', 'Step 2: Snap or upload a selfie', 'Step 3: See your new look in seconds!']
};

const HowUseContent = () => {
  return (
    <div className={styles.content}>
      <h2 className={styles.h2}>{contentInfo.h2}</h2>

      <div className={styles.container}>
        <Image
          className={styles.bigImgItem}
          src={'/images/hairstyle/how_to_use_bg.webp'}
          alt="icon"
          loading="lazy"
          width={1028}
          height={291}
        />

        <div className={styles.descList}>
          {contentInfo.h3List.map((item, index) => (
            <div key={index}>
              <h3>{item}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowUseContent;
